<template>
  <v-layout class="summary--row">
    <v-flex v-bind="columnSizeAttrs" class="label">
      <p>
        {{label}}
        <span v-if="subLabel">
          <br/>
          <small>{{subLabel}}</small>
        </span>
      </p>
    </v-flex>
    <v-flex
      v-bind="columnSizeAttrs"
      class="font-weight-bold text-xs-right value">
      <p>{{(type === 'date' ? formattedValue : value) || 'n/a'}}</p>
    </v-flex>
  </v-layout>
</template>

<script>
import Moment from 'moment';


const COLUMN_SIZE_ATTRIBUTES = {
  xs12: true,
  md6: true,
  'py-0': true,
};

export { COLUMN_SIZE_ATTRIBUTES };
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    subLabel: {
      type: String,
      default: '',
    },
    value: {
      type: [Number, String, Boolean],
      required: false,
    },
    type: {
      type: String,
      required: false,
    },
  },
  computed: {
    formattedValue() {
      if (this.value) {
        return Moment(this.value).format('MM-DD-YYYY');
      }

      return 'n/a';
    },
  },
  data() {
    return {
      columnSizeAttrs: COLUMN_SIZE_ATTRIBUTES,
    };
  },
};
</script>

<style lang="scss" scoped>
$_row-vertical-padding: 1.175rem;

.summary--row {
  padding: $_row-vertical-padding 0;

  p {
    margin: 0;
  }
}
</style>
